import { apiTenant } from '@api/admin';
import React, { createContext, useContext, useMemo, useState } from 'react';

export const TenantContext = createContext<Partial<TenantContextProps>>({});

const TenantContextProvider = (props: TenantContextProviderProps) => {
  const [tenant, setTenant] = useState<Tenant>(props.tenant);
  const subdomain = props.subdomain;
  const tenantUrl = useMemo(() => {
    const { env } = props;
    if (env.isDev) return `http://${subdomain}.orangelms.com:4000`;
    if (env.isStaging) return `https://${subdomain}.stg.mundolms.com`;
    if (env.isProduction) return `https://${subdomain}.mundolms.com`;
    throw {
      message: `Wrong LMSEnv @TenantContextProvider; ${JSON.stringify(props)}`,
    };
  }, [tenant]);

  const refreshTenant = async (subdomain: string) => {
    try {
      const res = await apiTenant.get(subdomain);
      if (res.ok) {
        setTenant(res.data);
      }
    } catch {}
  };

  return (
    <TenantContext.Provider value={{ tenant, refreshTenant, setTenant, subdomain, tenantUrl }}>
      {props.children}
    </TenantContext.Provider>
  );
};

export default TenantContextProvider;

export function useTenant() {
  const context = useContext(TenantContext);
  return context;
}

type TenantContextProps = {
  children: React.ReactNode;
  tenant: Tenant;
  setTenant: Function;
  refreshTenant: Function;
  subdomain: string;
  tenantUrl: string;
};

type TenantContextProviderProps = {
  env: LMSEnv;
  children: React.ReactNode;
  tenant: Tenant;
  subdomain: string;
};
